export default __webpack_public_path__ + "static/media/financialsituation3Img2.f3c2fa1a.png";